import * as Routes from '../js/routes.js.erb';
import { escapeHtml } from '../js/html_escape.js';
window.Routes = Routes;
var $ = require("jquery");

$(document).on('turbo:load', function() {
    $(document).ready(function() {
        $('#main-city-info').empty();
        updateMainCity();
    });
    let timeout = null;
    $('body').on("keyup", '#main-ort-search', async function() {
        let element_ = $("#main-city-");
        element_.empty();
        element_.append(`<div class="row mt-3"><div class="col-12 justify-content-center text-center"><div class="spinner-border text-primary text-center" role="status"></div></div></div>`);
        let search_text = document.getElementById("main-ort-search").value;
        clearTimeout(timeout);
        timeout = setTimeout(async function () {
          let suggestions = await getSuggestions(search_text);
          element_.empty();
          $.each(suggestions.data, function(key, value) {
            element_.append(`<li class="row mt-3" data-id="${value["id"]}" data-name="${escapeHtml(value["name"])}" data-logo="${value["logo"]}">
            <a class="align-items-center d-flex link-dark text-decoration-none" href="/welcome?ort=${value["id"]}"><div class="col-10">
            <img style="height: 35px" class="img-fluid" src="${value["logo"] ? value["logo"] : '/icons/app_logo.svg'}">
            <span class="mb-0 ps-2">${escapeHtml(value["name"])}</span>
            </div>
            <div class="col-2 d-flex justify-content-end pe-0">
            <div class="icon-arrow-right-1 text-default-gray"></div>
            </div>
            </a><hr class="mt-1 border">
            </li>`);
          });
          if (suggestions.data.length < 1){
              element_.append(`<div style="display: flex; flex-direction: column; align-items: center;">
                                <h3 style="font-size: 1.5em;" class="fw-bold">Dein Wunschort ist nicht verfügbar?</h3>
                                <p style="margin-top: 10px;" class="text-center m-0">
                                  Schreibe uns eine Nachricht mit unserem Kontaktformular - wir nehmen
                                  Kontakt mit Deiner Verwaltung auf.
                                </p>
                              <a href="/kontakt?ort_unavailable&placeName=${encodeURIComponent(search_text)}" style="margin-top: 10px;">Zum Kontaktformular</a>
                            </div>
                          `);
          }
          $('ul#main-city- li').click(async function(e) {
            // e.preventDefault();
            let ort_id = $(this).data("id");
            let old_ort_id = JSON.parse(localStorage.getItem('main_city'))['id'];
            let new_fav = { id: ort_id, name: $(this).data("name"), logo: $(this).data("logo") };
            window.localStorage.setItem('main_city', JSON.stringify(new_fav));
            updateMainCity();
            await change_push_subscription_ort(ort_id, old_ort_id);
            Turbo.visit(`/welcome?ort=${ort_id}`, { action: 'replace' });
          });
        }, 500);
    });
});

async function getSuggestions(search) {
    const response = await fetch('/ort-search?search=' + search, {
        method: 'get',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    }).then(res => res.clone().json())
    return response;
}

async function change_push_subscription_ort(ort_id, old_ort_id) {
    navigator.serviceWorker && await navigator.serviceWorker.ready.then(async registration => {
        await registration.pushManager.getSubscription()
            .then(async subscription => {
                if (subscription) {
                    await window.Notification.requestPermission().then(async permission => {
                        let main_city_ = JSON.parse(localStorage.getItem('main_city'));
                        if (permission === 'granted') {
                            localStorage.setItem('notification_city', JSON.stringify(main_city_));
                            window.localStorage.setItem('notification_types', JSON.stringify({
                                'push-kind-1': true,
                                'push-kind-2': true,
                                'push-kind-3': true,
                                'push-kind-4': true,
                                'push-kind-5': true,
                            }));
                            let formData = new FormData();
                            formData.append('ort_id', ort_id);
                            formData.append('old_ort_id', old_ort_id);
                            formData.append('subscription', JSON.stringify(subscription));
                            return await fetch(Routes.change_ort_subscription_path(), {
                                method: 'post',
                                headers: {
                                    "X-CSRF-Token": document.querySelectorAll('meta[name="csrf-token"]')[0]["content"],
                                    'X-Requested-With': 'XMLHttpRequest',
                                },
                                body: formData
                            });
                        }
                    });
                }
            })
            .catch(function(err) {
                console.log('Error during getSubscription()', err);
            });
    });
}

function updateMainCity() {
    var main_city = JSON.parse(window.localStorage.getItem("main_city"));
    main_city && $('#main-city-info').append(
        `<li class="row mt-3" data-id="${main_city["id"]}">
              <a class="col-11 align-items-center d-flex link-dark text-decoration-none" href="/welcome?ort=${main_city["id"]}">
                  <img style="height: 35px" class="img-fluid" src="${main_city["logo"] !== 'undefined' ? main_city["logo"] : '/icons/app_logo.svg'}">
                  <span class="mb-0 ps-2">${escapeHtml(main_city["name"])}</span>
              </a>
              <div class="col-1 d-flex justify-content-end pe-0 align-items-center">
                <div class="icon-arrow-right-1 text-default-gray pe-3"></div>
              </div>
              <hr class="mt-1">
              </li>`
    );
}
